import React from "react";
import { Link } from "react-router-dom";



export default function VehicleSparepartsDetail1() {
    return (
        <div className="vehiclesparepartsdatail-container my-4">
            {/* Header */}
            <div className="special-header d-flex justify-content-between align-iteam">
            <h4 className="page-title pt-2">Vehicle Spareparts Details</h4>
            <div className="d-flex  align-items-center gap-2">
             <Link to="/updatevehiclespareparts" type="button" className="btn custom-btn">Edit</Link>
              <button type="button" className="btn custom-btn">Delete</button>
             </div>
            </div>

            {/* Table */}
            <div className="card col-md-12">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="custom-table  table-bordered mb-0">
                            <tbody>
                                <tr>

                                    <td style={{ width: "500px" }}>Vehicle Name</td>
                                    <td>Uber Vehicle</td>

                                </tr>
                                <tr>

                                    <td>Spareparts</td>
                                    <td>Side Mirror</td>

                                </tr>
                                <tr>

                                    <td>Warranty</td>
                                    <td>1</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Purchase Date</td>
                                    <td>Thu Dec 16 2021</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Expiry Dare</td>
                                    <td>Fri Dec 31 2021</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Quantity</td>
                                    <td>1</td>
                                   
                                </tr>

                                <tr>

                                    <td>Quantity</td>
                                    <td>$2343</td>
                                   
                                </tr>


                                <tr>

                                    <td>Invoice</td>
                                    <td>Not Uploaded</td>
                                   
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
        </div>

    );

}